import React from "react";

const NotFound = () => (
  <div className="text-center py-12">
    <h2 className="text-2xl font-bold text-gray-700">No articles found</h2>
    <p className="text-gray-500 mt-2">
      Try adjusting your search or check back later.
    </p>
  </div>
);

export default NotFound;
